import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./UserDetails.styles";
import Grid from "@material-ui/core/Grid/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import { AddressCard } from "../OrderDetails/AddressCard";
import { isEuCountry } from "../../../utilities/countriesUtils";
import { useTranslation } from "react-i18next";

export interface IUserDetailsProps extends WithStyles<typeof styles> {
    userDetails: any;
    countries: any[];
}

const UserDetailsPure: React.FunctionComponent<IUserDetailsProps> = ({
    userDetails,
    countries,
    classes
}: IUserDetailsProps) => {
    const { t } = useTranslation();

    return (
        <div className={classes.topMargin}>
            <Grid container spacing={5} direction="row">
                <Grid item xs={6}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h6" className={classes.cardTitle}>
                                User's information
                            </Typography>
                            <Typography variant="body2">
                                Name: {userDetails.firstName} {userDetails.lastName}
                            </Typography>
                            <Typography variant="body2">Email: {userDetails.email}</Typography>
                            <Typography variant="body2">Phone number: {userDetails.phone}</Typography>
                            {userDetails.tin !== "" ? (
                                <Typography variant="body2">VAT ID: {userDetails.tin}</Typography>
                            ) : (
                                userDetails.deliveryAddress.country &&
                                isEuCountry(countries, userDetails.deliveryAddress.country) && (
                                    <Typography variant="body2" className={classes.paymentError}>
                                        VAT ID is mandatory for EU residents!
                                    </Typography>
                                )
                            )}
                            <Typography variant="body2">
                                Company: {userDetails.company ? userDetails.company : "was not provided"}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={3}>
                    <AddressCard
                        float
                        address={userDetails.billingAddress}
                        title={t("orderDetails.title.billingAddress")}
                    />
                </Grid>
                <Grid item xs={3}>
                    <AddressCard float address={userDetails.deliveryAddress} title={t("general.deliveryAddress")} />
                </Grid>
            </Grid>
        </div>
    );
};

export const UserDetails = withStyles(styles)(UserDetailsPure);
